import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import Swal from "sweetalert2";
import { Subject } from "rxjs";
import { environment } from 'environments/environment';
import { PedidoInterface } from "app/module/pedido-interface";
import moment from "moment";
import { ClienteFechamentoService } from "@core/services/cliente-fechamento.service";
import { ToastrService } from "ngx-toastr";

@Component({
	selector: 'app-listar-cliente-fechamento',
	templateUrl: './listar-cliente-fechamento.component.html',
	styleUrls: ['./listar-cliente-fechamento.component.scss']
})
export class ListarClienteFechamentoComponent implements OnInit {

	constructor(private clienteFechamentoService: ClienteFechamentoService, private renderer: Renderer2, private toastr: ToastrService) {
		this._unsubscribeAll = new Subject();
	}

	private _unsubscribeAll: Subject<any>;
	private tempData = [];

	loadingPage = false;
	contentHeader: object;
	basicSelectedOption: number = 10;
	ColumnMode = ColumnMode;
	rows: Array<PedidoInterface> | any = [];
	temp: Array<PedidoInterface> | any = [];

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	ngOnInit(): void {
		this.loadingPage = true;
		this.contentHeader = {
			headerTitle: "Faturas",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Faturas",
						isLink: false,
					},
				],
			},
		};

		this.clienteFechamentoService.findAll().subscribe(
			(res) => {
				if (res.length > 0) {
					this.rows = res
					this.temp = res
					this.tempData = this.rows
				}
				this.loadingPage = false;
			},
			(error) => {
				console.log(error);
				this.msgErroInterno();
			}
		);
	}

	textFilter(event, param) {
		const val = event.target.value.toLowerCase();
		const temp = this.temp.filter(function (d) {
			return d[param].toLowerCase().indexOf(val) !== -1 || !val;
		});
		this.rows = temp;
	}

	dateFilter(event) {
		const val = event.target.value.toLowerCase();
		const [day, month, year] = val.split("/");
		const result = [year, month, day].join("-");
		if (val.length < 10) {
			this.rows = this.temp;
		}
		if (val.length == 10) {
			const temp = this.temp.filter(function (d) {
				return d.dt_insert.substring(0, 10).toLowerCase().indexOf(result) !== -1 || !result;
			});
			this.rows = temp;
			this.table.offset = 0;
		}
	}

	msgErroInterno() {
		this.loadingPage = false;
		Swal.fire({
			title: "Erro!",
			text: "Ocorreu um erro interno.",
			icon: "error",
			confirmButtonText: "Confirmar",
			confirmButtonColor: '#ef6767',
		});
	}

	confirmDeleteAlert() {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja excluir o item?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Excluir",
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-danger",
				cancelButton: "btn btn-primary ml-1",
			},
		}).then((result) => {
			if (result.isConfirmed) {
				// chamar servico de remover
			}
		});
	}

	visualizaFatura(token) {
		window.open(`${environment.g2e_www}fatura/${token}`, '_blank');
	}

	copiarLinkFatura(token) {
		navigator.clipboard.writeText(`${environment.g2e_www}fatura/${token}`)
			.then(() => {
				console.log('Text copied to clipboard');
				Swal.fire({
					title: "Copiado!",
					text: "Link copiado para a área de transferência.",
					icon: "success",
					confirmButtonText: "Confirmar",
					customClass: {
						confirmButton: "btn btn-primary ml-1",
					},
				});
			})
			.catch((error) => {
				console.error('Error copying text to clipboard:', error);
			});
	}
}
